<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.regulationId" hidden/>

        <b-row>

          <t-input v-model="form.name" cols="4" :add-error="error.name" label="Norma" required/>

          <t-input v-model="form.title" cols="8" label="Título" required/>

        </b-row>

        <t-input v-model="form.typeRegulationId"
                 required
                 :options="typeRegulationOptions"
                 label="Categoria de Norma" select/>

        <label>Descrição técnica</label>
        <vue-editor
            ref="editorComment"
            :editor-toolbar="customToolbar"
            :disabled="status === 'sending'"
            v-model="form.description">
        </vue-editor>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import TypeRegulationService from "@/services/modules/checklist/TypeRegulation.service";
import {VueEditor} from "vue2-editor";
import ui from "@/assets/scripts/ui";

export default {
  components: {VueEditor},
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'RegulationForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "regulationId",
      form: {
        regulationId: 0,
        regulationNumber: 0,
        typeRegulationId: 0,
        name: "",
        title: "",
        description: "",
        note: "",
        degree: 1,
        orderList: 1,/*todo*/
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        degree: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeRegulationOptions: [],
      /*ATENÇÃO SOMENTE CAMPOS BÁSICOS, POIS NÃO CABE NO JASPER.*/
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await TypeRegulationService.selectList().then((list) => {
        this.typeRegulationOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      if (this.form.description.length === 0) {
        ui.msgError(this, "Preencha a descrição técnica para continuar")
      } else {

        //Corrigir strong por b
        this.form.description = this.form.description.replace(/<strong>/i, '<b>')
        this.form.description = this.form.description.replace(/<\/strong>/i, "</b>")

        //Limitar para até 5000 caracteres
        if (this.form.description.length > 5000)
          this.form.description = this.form.description.substring(0, 5000)

        await this.setSendingDefault()
      }

    },
//--------------------------------------------------------------------------------------
//Início de métodos personalizados desta tela


//--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

